import { useTranslation } from 'react-i18next';
import Iconify from 'src/components/Iconify';
import { Alert, AlertDescription } from 'src/@/components/ui/alert';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from 'src/@/components/ui/accordion';
import { Switch } from 'src/@/components/ui/switch';

export default function EnvioCrmParceiroSection({ aiAgent, changeModuleConfig }) {
    const { t } = useTranslation('settings');
    const realstate = aiAgent?.config?.module?.realstate || {};
    const funcoes = realstate.funcoes || {};
    const cfg = funcoes.envioCrmParceiro || {};

    const updateCfg = (patch) => {
        changeModuleConfig({
            funcoes: {
                ...funcoes,
                envioCrmParceiro: { ...cfg, ...patch },
            },
        });
    };

    return (
        <Accordion
            type="single"
            collapsible
            className="rounded-xl border border-gray-100 bg-white"
        >
            <AccordionItem value="envio-crm" className="border-0">
                <AccordionTrigger className="hover:no-underline px-6 py-4 [&[data-state=open]]:pb-3">
                    <div className="flex items-start justify-between gap-3 flex-1 pr-3 text-left">
                        <div className="flex items-center gap-3">
                            <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-violet-50 shrink-0">
                                <Iconify icon="mdi:database-export-outline" width={20} className="text-violet-600" />
                            </div>
                            <div>
                                <div className="text-base font-semibold text-gray-900 leading-tight">{t('aiAgents.realstate.envioCrmParceiro.title', 'Envio do Lead ao CRM Parceiro')}</div>
                                <div className="text-sm text-gray-500 font-normal mt-1">
                                    {t('aiAgents.realstate.envioCrmParceiro.subtitle', 'Quando todas as perguntas qualificatórias forem respondidas, a Lais envia o lead ao CRM da imobiliária parceira — uma única vez.')}
                                </div>
                            </div>
                        </div>
                        <div
                            role="presentation"
                            onClick={(e) => e.stopPropagation()}
                            onPointerDown={(e) => e.stopPropagation()}
                            onKeyDown={(e) => e.stopPropagation()}
                            className="shrink-0"
                        >
                            <Switch
                                checked={!!cfg.ativo}
                                onCheckedChange={(value) => updateCfg({ ativo: value })}
                            />
                        </div>
                    </div>
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-6">
                    {!cfg.ativo ? (
                        <p className="text-xs text-gray-500 italic">{t('aiAgents.realstate.envioCrmParceiro.ativeParaConfigurar', 'Ative o recurso acima para configurar.')}</p>
                    ) : (
                        <Alert className="bg-violet-50 border-violet-200 text-violet-800">
                            <AlertDescription className="text-xs">
                                <strong>{t('aiAgents.realstate.envioCrmParceiro.idempotenteStrong', 'Idempotente:')}</strong>{' '}
                                {t('aiAgents.realstate.envioCrmParceiro.idempotenteText', 'o lead é enviado uma única vez. Em caso de falha de rede/HTTP, a Lais tenta de novo na próxima atualização do lead. Status e resposta do parceiro ficam registrados no histórico do lead para diagnóstico.')}
                            </AlertDescription>
                        </Alert>
                    )}
                </AccordionContent>
            </AccordionItem>
        </Accordion>
    );
}
